module.exports = __webpack_public_path__ + "img/pocket-17_en.ab6c2d6.jpg";